module.exports = __webpack_public_path__ + "img/tita.bcc566a8.png";